import * as tslib_1 from "tslib";
import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';
import { isSubjectPickerSupported } from 'owa-mail-subject-picker-connector';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SubjectPicker" */ './lazyIndex');
});
export var SubjectPicker = createLazyComponent(lazyModule, function (m) { return m.SubjectPicker; });
export var lazyBackButtonPressed = new LazyImport(lazyModule, function (m) { return m.backButtonPressed; });
export var lazyBackButtonHovered = new LazyImport(lazyModule, function (m) { return m.backButtonHovered; });
export { doesSubjectPickerSupportPersona } from './utils/doesSubjectPickerSupportPersona';
export function loadSubjectPickerModule() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isSubjectPickerSupported()) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyModule.import()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=index.js.map